export const ASSESSMENT_WIZARD_EVENT_NAMES = {
  VIEWED_PAGE: 'Viewed Assessment Wizard',
  VIEWED_QUERY_TOOLTIP: 'Viewed Assessment Wizard Query Tooltip',
  SUBMITTED: 'Submitted Assessment Wizard',
  OPENED_AI_DISCLAIMER: 'Opened AI Disclaimer Modal'
}
